module.exports = __webpack_public_path__ + "img/pr-10.5daa07a5.png";